<template>
    <li @click="forwardToAlarmPage()">
        <span class="icon material-icons">
            {{ iconName }}
        </span>
        <span>
            {{ alarmTitle }}
        </span>
    </li>
</template>

<script>
export default {
    props: ["iconName", "alarmTitle"],
    methods: {
        forwardToAlarmPage() {
            this.$router.replace("/alarms")
        }
    }
}
</script>